import React from 'react';
import CommandPalette from '@/components/ui/command-palette';
import { useCommandPalette } from '@/hooks/useCommandPalette';

const GlobalCommandPalette = () => {
  const { open, setOpen } = useCommandPalette();

  return <CommandPalette open={open} onOpenChange={setOpen} />;
};

export default GlobalCommandPalette;